
import { computed, defineComponent } from "vue";
import { ElMessage } from "element-plus";
import { useStore } from "vuex";
import { IGlobalState } from "@/store";

export default defineComponent({
  setup() {
    const store = useStore<IGlobalState>();
    const application = computed(() => store.state.frontApp.application);
    /**
     * 复制
     */
    function copyContent(value: string) {
      const oInput = document.createElement("input");
      oInput.value = value;
      document.body.appendChild(oInput);
      oInput.select(); // 选择对象
      document.execCommand("Copy"); // 执行浏览器复制命令
      oInput.className = "oInput";
      oInput.style.display = "none";
      ElMessage({ message: "复制成功", type: "success" });
    }
    return {
      application,
      copyContent
    };
  },
});
